import { initializeApp } from 'firebase/app'
import {
  getFirestore,
  collection,
  doc,
  getDocs,
  getDoc,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  orderBy,
  where,
  Timestamp,
  type DocumentData,
} from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyBmMwslNC22vfoaE30bhTfNLlB_l2xjP5k',
  authDomain: 'theo-edumaeket-rwanda.firebaseapp.com',
  projectId: 'theo-edumaeket-rwanda',
  storageBucket: 'theo-edumaeket-rwanda.firebasestorage.app',
  messagingSenderId: '382020017659',
  appId: '1:382020017659:web:1bf9423669e197412b7f5e',
  measurementId: 'G-BGVMVSS660',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)

// Collection references
export const filesCollection = collection(db, 'files')
export const paymentsCollection = collection(db, 'payments')
export const messagesCollection = collection(db, 'messages')
export const notificationsCollection = collection(db, 'notifications')
export const usersCollection = collection(db, 'users')
export const fileDataCollection = collection(db, 'fileData')

export {
  db,
  app,
  collection,
  doc,
  getDocs,
  getDoc,
  setDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  query,
  orderBy,
  where,
  Timestamp,
}
export type { DocumentData }
